import { circularProgressClasses as r } from "@mui/material";
const e = {
  styleOverrides: {
    root: () => ({
      [`.${r.circle}`]: {
        strokeLinecap: "round"
      }
    })
  }
};
export {
  e as circularProgress
};
//# sourceMappingURL=circularProgress2.mjs.map
